import {LiveImage} from "../../api/image";
import ImageProcessor from "../ImageProcessor";
import {ISize} from "../ImageProcessor";
import ValidateError from './ValidateError';

interface IMinImageSizeAsyncOptions {
  width: number;
  height: number;
}

class MinImageSizeValidateError extends ValidateError {
  constructor(width: number, height: number) {
    super('error.too_small_image', 'image');
    this._data.height = height;
    this._data.width = width;

  }
}

export default async function minImageSizeAsync(value: LiveImage, options: IMinImageSizeAsyncOptions): Promise<ValidateError> {
  let {width, height} = options;
  let size: ISize = {width, height};

  if (value && value instanceof LiveImage) {
    let processor = new ImageProcessor(value.url);
    let isSmaller = await processor.isSmaller(size);

    if (isSmaller) {
      return new MinImageSizeValidateError(options.width, options.height);
    } else {
      return undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilites/validate/minImageSize.ts